import React, { Component } from 'react'
import { connect } from 'react-redux'
import styled from 'styled-components'

import lineApp from 'assets/pngs/line-app.png'
import Truckbook from 'assets/svgs/monoful-logo-background-white.svg'
import SMSIcon from 'assets/svgs/sms.svg'
import { TIME_AUTO_REDIRECT_CHECKIN } from 'constants/misc'
import theme from 'vars/theme'

import Header from '../components/Header'
import PrevStartButton from '../components/PrevStartButton'
import { SpFrame } from '../components/SpFrame'
import SessionStorage from '../SessionStorage'
import { isSp } from '../utils'

export const Wrapper = styled.div`
  background-color: ${theme.graySoft6};
  height: calc(var(--vh, 1vh) * 100);
  font-size: 18px;
  overflow: auto;
`

export const IconWrapper = styled.div`
  ${(props) =>
    props.sms
      ? ` width: 120px;
          height: 120px;
          margin: 24px 0 0;
        `
      : `
          width: 180px;
          height: 180px;
          margin: 24px 0;
  `}

  ${(props) =>
    props.isSp === true &&
    `
      display: flex;
      justify-content: center;
      align-items: center;
      margin: 0;
  `}
`

const LogoImage = styled.img`
  width: 100%;
  height: 100%;
`

const NotificationContent = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`

const Text = styled.p`
  font-size: ${(props) => (props.isSp === true ? '16px' : '28px')};

  ${(props) =>
    props.sms &&
    `
      line-height: 1.2;
      font-size: ${props.isSp === true ? '28px' : '62px'};
      font-weight: bold
  `}
`

export const TextNoteMessage = styled.p`
  font-size: ${(props) => (props.isSp === true ? '16px' : '28px')};
  padding: 12px;
  margin-top: 4px;
  background: ${theme.redPrimary1};
  color: ${theme.whitePrimary};
  font-weight: 500;
`

const PortalIconWrapper = styled.div`
  width: ${(props) => (props.isSp === true ? '126px' : '180px')};
  height: ${(props) => (props.isSp === true ? '126px' : '180px')};
  margin: ${(props) => (props.isSp === true ? '0' : '24px 0')};
  padding: ${(props) => (props.isSp === true ? '21px' : '30px')};
  border-radius: 32px;
  box-shadow: 0px 0px 9px 4px ${theme.graySoft17};

  ${(props) =>
    props.isSp === true &&
    `
      display: flex;
      justify-content: center;
      align-items: center;
    `}
`
const DefaultTextContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  min-height: 250px;
`

class EntryFinishPage extends Component {
  constructor(props) {
    super(props)
    this.state = {
      isSp: isSp(),
    }
  }

  timerId = 0

  componentDidMount() {
    const { match, returnEntryPage, history } = this.props
    const {
      params: { warehouseId, tenantId },
    } = match

    if (returnEntryPage) {
      history.push(`/receipt-booking/${warehouseId}/${tenantId}`)
      return
    }

    const spRedirectUrl = '//www.hacobell.com/truckbook'
    this.timerId = this.state.isSp
      ? setTimeout(() => {
          window.location.replace(spRedirectUrl)
        }, 3000)
      : setTimeout(() => {
          const multiTenantId = SessionStorage.read('multiTenantId')
          const url = multiTenantId
            ? `/mtenants/${multiTenantId}`
            : `/receipt-booking/${warehouseId}/${tenantId}`
          this.props.history.push(url)
        }, TIME_AUTO_REDIRECT_CHECKIN)
    // ページ更新する際にリダイレクト
    window.onbeforeunload = this.state.isSp
      ? (e) => {
          e.preventDefault()
          setTimeout(() => {
            window.location.replace(spRedirectUrl)
          }, 0)
          window.onbeforeunload = null // 無限ループ防止
        }
      : undefined

    window.addEventListener('resize', this.handleResize)
  }

  componentWillUnmount() {
    if (this.timerId) {
      clearTimeout(this.timerId)
      this.timerId = 0
    }
    window.onbeforeunload = null
    window.removeEventListener('resize', this.handleResize)
  }

  handleResize = () => {
    this.setState({ isSp: isSp() })
  }

  renderNotification = () => {
    const { driver, location } = this.props
    const driverCanSMS = driver?.tenant?.canSms
    const { lineFlag, portalFlag, isCheckedPhone } = location?.state?.methodNotification ?? {}
    const smsFlag = driverCanSMS && !lineFlag && !portalFlag

    if (smsFlag) {
      return (
        <>
          <Text isSp={this.state.isSp}>
            入場準備が出来次第、<b>SMS</b>でご案内します。
          </Text>
          {!isCheckedPhone && (
            <TextNoteMessage isSp={this.state.isSp}>
              次回受付も、同じパスコードを使用します
            </TextNoteMessage>
          )}
          <IconWrapper sms isSp={this.state.isSp}>
            <LogoImage src={SMSIcon} alt="" isSp={this.state.isSp} />
          </IconWrapper>
          <Text sms isSp={this.state.isSp}>
            SMS
          </Text>
        </>
      )
    }

    if (lineFlag) {
      return (
        <>
          <Text isSp={this.state.isSp}>
            入場準備が出来次第、<b>LINE</b>でご案内します。
          </Text>
          {!isCheckedPhone && (
            <TextNoteMessage isSp={this.state.isSp}>
              次回受付も、同じパスコードを使用します
            </TextNoteMessage>
          )}
          <IconWrapper isSp={this.state.isSp}>
            <LogoImage src={lineApp} alt="" isSp={this.state.isSp} />
          </IconWrapper>
        </>
      )
    }

    if (portalFlag) {
      return (
        <>
          <Text isSp={this.state.isSp}>入場準備が出来次第、ハコベルアプリでご案内します。</Text>
          {!isCheckedPhone && (
            <TextNoteMessage isSp={this.state.isSp}>
              次回受付も、同じパスコードを使用します
            </TextNoteMessage>
          )}
          <PortalIconWrapper isSp={this.state.isSp}>
            <LogoImage src={Truckbook} alt="" isSp={this.state.isSp} />
          </PortalIconWrapper>
          <h2 className="text-size32 mv12" style={this.state.isSp ? { fontSize: '28px' } : {}}>
            ハコベル
          </h2>
        </>
      )
    }
  }

  render() {
    const { driver, match, location } = this.props
    const driverCanSMS = driver?.tenant?.canSms
    const canUnmannedCheckin = location?.state?.canUnmannedCheckin
    const { isCheckedPhone } = location?.state?.methodNotification ?? {}
    const {
      params: { warehouseId, tenantId },
    } = match
    const multiTenantId = SessionStorage.read('multiTenantId')
    if (this.state.isSp) {
      return (
        <Wrapper>
          <Header driver={driver} isSp />
          <div className="p-3">
            <SpFrame title="入場受付完了">
              <div className="mt-4">
                {!driverCanSMS ? (
                  <div style={{ fontSize: 18, color: theme.grayDark, lineHeight: 1.6 }}>
                    {canUnmannedCheckin
                      ? '作業完了後、退場受付をお願いいたします。'
                      : '入場準備が出来次第、別途ご案内します。'}

                    {!isCheckedPhone && (
                      <div style={{ marginTop: 16, fontSize: 16, color: '#999' }}>
                        次回受付も、同じパスコードを使用します
                      </div>
                    )}
                  </div>
                ) : (
                  <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                    {this.renderNotification()}
                  </div>
                )}
              </div>
            </SpFrame>
          </div>
        </Wrapper>
      )
    }

    return (
      <Wrapper>
        <Header driver={driver} />
        <div style={{ margin: 32 }}>
          <div className="bg-white p-5 mb-3" style={{ minHeight: 350, borderRadius: 12 }}>
            <div className="text-center">
              <div className="mb-2 font-weight-bold" style={{ fontSize: 48 }}>
                入場受付完了
              </div>
              {!driverCanSMS ? (
                <DefaultTextContent>
                  <div style={{ fontSize: 28 }}>
                    <Text>
                      {canUnmannedCheckin
                        ? '作業完了後、退場受付をお願いいたします。'
                        : '入場準備が出来次第、別途ご案内します。'}
                    </Text>

                    {!isCheckedPhone && (
                      <TextNoteMessage>次回受付も、同じパスコードを使用します</TextNoteMessage>
                    )}
                  </div>
                </DefaultTextContent>
              ) : (
                <NotificationContent>{this.renderNotification()}</NotificationContent>
              )}
            </div>
          </div>

          <div className="d-flex justify-content-between">
            <div style={{ width: '33%' }}>
              <PrevStartButton
                to={
                  multiTenantId
                    ? `/mtenants/${multiTenantId}`
                    : `/receipt-booking/${warehouseId}/${tenantId}`
                }
                data-dg-id="entry-finish-page-prev-start-button"
              />
            </div>
            <div style={{ width: '34%' }} />
            <div className="text-right" style={{ width: '33%' }} />
          </div>
        </div>
      </Wrapper>
    )
  }
}

const mapStateToProps = (state) => {
  const reception = state.get('reception')
  return {
    driver: reception.driver,
    returnEntryPage: reception.returnEntryPage,
  }
}

export default connect(mapStateToProps, null)(EntryFinishPage)
